import React from "react";
import { MessageSquareText, PhoneCall, StickyNote } from "lucide-react";
import type Note from "@/model/interface/Note";
import type { NoteKind } from "@/model/interface/Note";
import { formatTime } from "@/util/call";

interface NoteActivityItemProps {
  note: Note;
  timestamp: string;
}

const KIND_LABELS: Record<NoteKind, string> = {
  NOTE: "Note",
  CALL: "Call note",
  TEXT: "Text note",
};

const NoteActivityItem: React.FC<NoteActivityItemProps> = ({ note, timestamp }) => {
  const Icon = note.kind === "CALL" ? PhoneCall : note.kind === "TEXT" ? MessageSquareText : StickyNote;

  return (
    <div className="px-4 py-3">
      <div className="flex items-start gap-3">
        <div className="flex w-8 shrink-0 justify-center pt-0.5">
          <Icon className="h-4 w-4 text-muted-foreground" />
        </div>
        <div className="min-w-0 flex-1 space-y-1">
          <div className="flex flex-wrap items-center gap-2">
            <span className="text-sm font-medium">{KIND_LABELS[note.kind] ?? "Note"}</span>
            {note.authorName && <span className="text-xs text-muted-foreground">by {note.authorName}</span>}
          </div>
          <p className="whitespace-pre-wrap break-words text-sm">{note.body}</p>
        </div>
        <span className="shrink-0 text-xs tabular-nums text-muted-foreground">{formatTime(new Date(timestamp))}</span>
      </div>
    </div>
  );
};

export default NoteActivityItem;
